import { render } from "./featurePage.vue?vue&type=template&id=d355619e&scoped=true"
import script from "./featurePage.vue?vue&type=script&lang=js"
export * from "./featurePage.vue?vue&type=script&lang=js"

import "./featurePage.vue?vue&type=style&index=0&id=d355619e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d355619e"]])

export default __exports__